


const find1 = (state, action) => {
    return async () => {
        try {
            let response = await fetch(action.options.url);
            return await response.json();
        } catch (e) {
            console.log(e);
        }
    }
}
const find = async () => {
    try {
        return await fetch(action.options.url).then(res => res.json());
    } catch (e) {
        console.log(e);
    }
}



export default (state = {}, action) => {
    switch (action.type) {
        case 'find':
            (async () => {
                try {
                    let response = await fetch(action.options.url);
                    let list = await response.json();
                    console.log(list)
                } catch (e) {
                    console.log(e);
                }
            })()

            return state
        default:
            return state
    }
};




// WEBPACK FOOTER //
// ./reducers/base.js